import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CentroLogisticoCementoDto, CentroLogisticoCementoUpsertDto } from '../models/centro-logistico-cemento.dto';
import { ServerListQuery, ServerPaginatedResponse } from '../models/server-list.model';

@Injectable()
export class CentroLogisticoCementoApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}cemento/admin-logistic-centers/`;

  listItems(query: ServerListQuery): Observable<ServerPaginatedResponse<CentroLogisticoCementoDto>> {
    const params = new HttpParams()
      .set('page', String(query.page))
      .set('page_size', String(query.pageSize))
      .set('search', query.search)
      .set('ordering', query.ordering);
    return this.http.get<ServerPaginatedResponse<CentroLogisticoCementoDto>>(this.baseUrl, { params });
  }

  createItem(payload: CentroLogisticoCementoUpsertDto): Observable<void> {
    return this.http.post<unknown>(this.baseUrl, payload).pipe(map(() => undefined));
  }

  updateItem(id: number, payload: CentroLogisticoCementoUpsertDto): Observable<void> {
    return this.http.put<unknown>(`${this.baseUrl}${id}/`, payload).pipe(map(() => undefined));
  }

  deleteItem(id: number): Observable<void> {
    return this.http.delete<unknown>(`${this.baseUrl}${id}/`).pipe(map(() => undefined));
  }

  postExcelCargaMasiva(file: File): Observable<void> {
    const formData = new FormData();
    formData.append('excel', file);
    return this.http
      .post<unknown>(`${this.baseUrl}cargar_excel/`, formData)
      .pipe(map(() => undefined));
  }
}
